var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-menu",on:{"click":_vm.gotoMapMenu}},[_c('img',{staticClass:"map-icon-item",attrs:{"src":require("../assets/images/gallery1/icons/map-icon-menu.png"),"width":"28","height":"28","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }